import { render } from "./Imprint.vue?vue&type=template&id=22a6917e"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andremichaelis/Websites/gmf.goldspruch/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__